import { render, staticRenderFns } from "./msw-partner-resources.vue?vue&type=template&id=0c8d43d2&scoped=true&"
import script from "./msw-partner-resources.vue?vue&type=script&lang=ts&"
export * from "./msw-partner-resources.vue?vue&type=script&lang=ts&"
import style0 from "./msw-partner-resources.vue?vue&type=style&index=0&id=0c8d43d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8d43d2",
  null
  
)

export default component.exports